import { getColors } from '../../charts/shared/palettes';

/**
 * Compute the list of color-mapped items for the current chart + data.
 * Returns [{ key, label, autoColor }] or empty array when not applicable.
 */
export function computeColorMapItems(chartTypeId, config, data, mapping, theme) {
  if (!data || !Array.isArray(data) || data.length === 0) return [];

  const chartId = chartTypeId;

  // Universal colorBy: any chart whose data carries _colorBy gets a color map
  if (data[0]?._colorBy != null) {
    const unique = [...new Set(data.map(d => d._colorBy))];
    const effectiveConfig = (config.primaryColor || config.useRedsPalette || config.useGreensPalette || config.colorPalette)
      ? config
      : { ...config, useBluesPalette: true };
    const baseColors = getColors(effectiveConfig, unique.length, theme);
    return unique.map((v, i) => ({
      key: v,
      label: v,
      autoColor: baseColors[i % baseColors.length],
    }));
  }

  if (chartId === 'grouped-bar' || chartId === 'horizontal-grouped-bar') {
    const seriesKeys = data._seriesKeys;
    const labelMap = data._labelMap;
    if (!seriesKeys?.length) return [];
    const baseColors = getColors(config, seriesKeys.length, theme);
    return seriesKeys.map((k, i) => ({
      key: labelMap?.[k] || k,
      label: labelMap?.[k] || `Series ${i + 1}`,
      autoColor: baseColors[i],
    }));
  }

  if (chartId === 'stacked-bar' || chartId === 'horizontal-stacked-bar') {
    const stackKeys = data._seriesKeys;
    const labelMap = data._labelMap;
    if (!stackKeys?.length) return [];
    const baseColors = getColors(config, stackKeys.length, theme).reverse();
    return stackKeys.map((k, i) => ({
      key: labelMap?.[k] || k,
      label: labelMap?.[k] || `Stack ${i + 1}`,
      autoColor: baseColors[i],
    }));
  }

  if (chartId === 'vertical-bar' || chartId === 'horizontal-bar' || chartId === 'lollipop') {
    if (data.length <= 1) return [];
    const baseColors = getColors(config, data.length, theme);
    return data.map((d, i) => ({
      key: d.name,
      label: d.name,
      autoColor: baseColors[i % baseColors.length],
    }));
  }

  if (chartId === 'scatter-plot') {
    const categories = [...new Set(data.map(d => d.category))];
    if (categories.length <= 1) return [];
    const baseColors = getColors(config, categories.length, theme);
    return categories.map((cat, i) => ({
      key: cat,
      label: cat,
      autoColor: baseColors[i % baseColors.length],
    }));
  }

  return [];
}
